export default __webpack_public_path__ + "static/media/66-min.32a80852.png";